module.exports = __webpack_public_path__ + "static/media/cms.a090138c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/cms.svg
// module id = 159
// module chunks = 0